const templateUrl = require('./pause-button.html');

module.exports = {
  bindings: {
    subscription: '<ogFor'
  },
  templateUrl: templateUrl
};
